import { render, staticRenderFns } from "./generador_albaran_cliente.vue?vue&type=template&id=284afcba&"
import script from "./generador_albaran_cliente.vue?vue&type=script&lang=js&"
export * from "./generador_albaran_cliente.vue?vue&type=script&lang=js&"
import style0 from "./generador_albaran_cliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports